module.exports = __webpack_public_path__ + "img/copy.90797c48.svg";